import { browser } from "$app/environment";
import { communitySlug } from "$stores/community";
import { get } from "svelte/store";

export function track(event: string) {
  if (browser) {
    window.posthog?.capture(event, { groupId: get(communitySlug) });
  }
}

export function trackNotAuthed(event: string, email: string, content: string) {
  if (browser) {
    window.posthog?.capture(event, { email, content });
  }
}

export function toPercent(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}
